// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function WalletBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M24.5 17.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm5-4v10a4 4 0 0 1-4 4h-18a4 4 0 0 1-4-4V8.615a4 4 0 0 1 4-4.115H24a1.5 1.5 0 0 1 0 3H7.5a1 1 0 0 0-1 1.033v.01a1.04 1.04 0 0 0 1.06.957H25.5a4 4 0 0 1 4 4Zm-3 0a1 1 0 0 0-1-1H7.56c-.358 0-.714-.045-1.06-.135V23.5a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-10Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
